module.exports = __webpack_public_path__ + "img/blue_036.38565b0a.png";